import { Edit, Plus, Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../../components/DataTable";
import StatusBadge from "../../components/StatusBadge";
import { api } from "../../lib/api";
import { AdminHeader } from "./AdminShell";

type ProductRow = { id: number; title: string; sku?: string; price: number; stock: number; status: string; image?: string };

export default function Products() {
  const [rows, setRows] = useState<ProductRow[]>([]);
  const [query, setQuery] = useState("");
  async function load() { setRows(await api<ProductRow[]>("/api/products")); }
  useEffect(() => { load().catch(() => setRows([])); }, []);
  const filtered = rows.filter((row) => `${row.title} ${row.sku}`.toLowerCase().includes(query.toLowerCase()));
  async function archive(id: number) {
    if (!confirm("Archive this product?")) return;
    await api(`/api/admin/products/${id}`, { method: "DELETE" });
    await load();
  }
  return (
    <div>
      <AdminHeader title="All Products" description="Add, edit, archive, and publish products with a single content language. Images use URLs in free deployment mode." action={<Link className="btn-primary" to="/admin/products/new"><Plus size={16} className="mr-2" />Add Product</Link>} />
      <div className="mb-5 flex flex-col gap-3 rounded-[24px] bg-white p-4 shadow-[0_16px_40px_rgba(15,23,42,0.06)] md:flex-row md:items-center">
        <input className="input md:max-w-sm" placeholder="Search products" value={query} onChange={(e) => setQuery(e.target.value)} />
        <a className="btn-secondary" href="/api/admin/export/products">Export CSV</a>
      </div>
      <DataTable rows={filtered as unknown as Record<string, unknown>[]} columns={[
        { key: "image", label: "Image", render: (row) => <img src={String(row.image || "/placeholder.webp")} className="h-14 w-14 rounded-2xl object-cover" /> },
        { key: "title", label: "Product" },
        { key: "sku", label: "SKU" },
        { key: "price", label: "Price" },
        { key: "stock", label: "Stock" },
        { key: "status", label: "Status", render: (row) => <StatusBadge status={String(row.status)} /> },
        { key: "id", label: "Actions", render: (row) => <div className="flex gap-2"><Link className="btn-secondary px-4 py-2" to={`/admin/products/${row.id}/edit`}><Edit size={15} /></Link><button className="btn-secondary px-4 py-2 text-red-600" onClick={() => archive(Number(row.id))}><Trash2 size={15} /></button></div> }
      ]} />
    </div>
  );
}
